export const actors = [
  {
    id: "a1",
    name: "林晚",
    avatar: "https://readdy.ai/api/search-image?query=elegant%20asian%20female%20actress%20portrait%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20cinematic%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-linwan&orientation=squarish",
    bio: "实力派女演员，以细腻的情感表达与强烈的角色张力著称，多次获得年度最佳女主角提名。",
  },
  {
    id: "a2",
    name: "沈砚",
    avatar: "https://readdy.ai/api/search-image?query=mature%20asian%20male%20actor%20portrait%2C%20dramatic%20side%20lighting%2C%20muted%20taupe%20background%2C%20cinematic%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-shenyan&orientation=squarish",
    bio: "从业二十余年的戏骨，擅长塑造复杂而立体的中年角色，被称为“行走的表演教科书”。",
  },
  {
    id: "a3",
    name: "苏叶子",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20female%20actress%20portrait%2C%20natural%20soft%20light%2C%20cream%20beige%20background%2C%20cinematic%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-suyezi&orientation=squarish",
    bio: "新生代人气演员，凭青春题材作品走红，气质清透，戏路宽广。",
  },
  {
    id: "a4",
    name: "陆行舟",
    avatar: "https://readdy.ai/api/search-image?query=handsome%20asian%20male%20actor%20portrait%2C%20moody%20low%20key%20lighting%2C%20dark%20charcoal%20background%2C%20cinematic%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-luxingzhou&orientation=squarish",
    bio: "兼具偶像气质与扎实演技的男演员，动作戏与文戏皆能驾驭。",
  },
  {
    id: "a5",
    name: "顾清欢",
    avatar: "https://readdy.ai/api/search-image?query=graceful%20asian%20female%20actress%20portrait%2C%20warm%20golden%20lighting%2C%20soft%20blush%20background%2C%20cinematic%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-guqinghuan&orientation=squarish",
    bio: "气质典雅的女演员，常出演年代剧与文艺片，台词功底深厚。",
  },
  {
    id: "a6",
    name: "周砚清",
    avatar: "https://readdy.ai/api/search-image?query=serious%20asian%20male%20actor%20portrait%2C%20cinematic%20teal%20shadow%20lighting%2C%20grey%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-zhouyanqing&orientation=squarish",
    bio: "以悬疑与犯罪题材见长的男演员，眼神戏极具穿透力。",
  },
  {
    id: "a7",
    name: "许微光",
    avatar: "https://readdy.ai/api/search-image?query=youthful%20asian%20female%20actress%20portrait%2C%20airy%20soft%20lighting%2C%20pale%20cream%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-xuweiguang&orientation=squarish",
    bio: "从选秀舞台走向荧屏的新人，灵动自然，被观众称为“会呼吸的表演”。",
  },
  {
    id: "a8",
    name: "裴野",
    avatar: "https://readdy.ai/api/search-image?query=rugged%20asian%20male%20actor%20portrait%2C%20warm%20amber%20lighting%2C%20deep%20brown%20background%2C%20cinematic%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-peiye&orientation=squarish",
    bio: "硬朗外型下藏着细腻表达，擅长饰演背负秘密的边缘人物。",
  },
  {
    id: "a9",
    name: "温柔",
    avatar: "https://readdy.ai/api/search-image?query=gentle%20asian%20female%20actress%20portrait%2C%20soft%20diffused%20light%2C%20dusty%20rose%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-wenrou&orientation=squarish",
    bio: "话剧出身的实力演员，表演收放自如，尤其擅长家庭与伦理题材。",
  },
  {
    id: "a10",
    name: "江照",
    avatar: "https://readdy.ai/api/search-image?query=charismatic%20asian%20male%20actor%20portrait%2C%20dramatic%20rim%20light%2C%20dark%20slate%20background%2C%20cinematic%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-jiangzhao&orientation=squarish",
    bio: "兼具书卷气与锋芒的青年演员，古装与现代戏皆宜。",
  },
  {
    id: "a11",
    name: "白梧",
    avatar: "https://readdy.ai/api/search-image?query=cool%20asian%20female%20actress%20portrait%2C%20moody%20contrast%20lighting%2C%20charcoal%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-baiwu&orientation=squarish",
    bio: "以冷艳角色出圈的女演员，气场强大，擅长动作与悬疑题材。",
  },
  {
    id: "a12",
    name: "程屿",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20asian%20male%20actor%20portrait%2C%20bright%20natural%20lighting%2C%20soft%20sage%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-chengyu&orientation=squarish",
    bio: "亲和力十足的男演员，喜剧与生活流题材中的常客。",
  },
  {
    id: "a13",
    name: "宋子衿",
    avatar: "https://readdy.ai/api/search-image?query=refined%20asian%20female%20actress%20portrait%2C%20elegant%20soft%20light%2C%20ivory%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-songzijin&orientation=squarish",
    bio: "知识分子家庭的优雅代表，常在历史与年代剧中担纲。",
  },
  {
    id: "a14",
    name: "罗川",
    avatar: "https://readdy.ai/api/search-image?query=stoic%20asian%20male%20actor%20portrait%2C%20low%20key%20studio%20lighting%2C%20warm%20graphite%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-luochuan&orientation=squarish",
    bio: "低调而高产的性格演员，擅长小人物与反派的多面塑造。",
  },
  {
    id: "a15",
    name: "叶知秋",
    avatar: "https://readdy.ai/api/search-image?query=lively%20asian%20female%20actress%20portrait%2C%20warm%20playful%20lighting%2C%20soft%20peach%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-yezhiqiu&orientation=squarish",
    bio: "综艺感与演技兼具的多栖艺人，舞台与镜头前都极具感染力。",
  },
  {
    id: "a16",
    name: "韩澈",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20male%20actor%20portrait%2C%20fresh%20clean%20lighting%2C%20light%20grey%20background%2C%20editorial%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-hanche&orientation=squarish",
    bio: "少年感与破碎感并存的年轻演员，是近年青春片的高频面孔。",
  },
];